
import FamilyTopNavbar from "./components/FamilyTopNavbar";
import RequestAccess from "./components/RequestAccess";

export function FamilyRequestAccessPage() {

  return (
    <div style={{ height: "100vh" }}>
      <div className="min-h-screen flex flex-column ">
        <FamilyTopNavbar />
        <div className="flex flex-column flex-auto p-3">
          <RequestAccess />

        </div >
      </div >
    </div >
  )
}